export const completedTask = [
    {
      date: "Thursday,24,2000",
      details: [
        {
          name: "Melanie Laurent",
          id: "324424",
          assessment: "Comprehensive Assessment",
          taskId: "232323",
          date: "December 22, 2022 10:30 AM",
          duration: "1 hour",
          status: "Overdue",
          button: "Start Assessment",
        },
      ],
    },
    {
      date: "Thursday,24,2003",
      details: [
        {
          name: "Melanie Laurent",
          id: "324425",
          assessment: "Physiotherapy Assessment",
          taskId: "232323",
          date: "December 22, 2022 10:30 AM",
          duration: "1 hour",
          status: "Upcoming",
          button: "Continue Assessment",
        },
        {
          name: "Melanie Laurent",
          id: "324426",
          assessment: "Comprehensive Assessment",
          taskId: "232323",
          date: "December 22, 2022 10:30 AM",
          duration: "1 hour",
          status: "Overdue",
          button: "Start Assessment",
        },
        {
          name: "Melanie Laurent",
          id: "324427",
          assessment: "Comprehensive Assessment",
          taskId: "232323",
          date: "December 22, 2022 10:30 AM",
          duration: "1 hour",
          status: "Overdue",
          button: "Start Assessment",
        },
      ],
    },
  ];

  export const upcomingTask = [
    

        {
          name: "Melanie Laurent",
          id: "324424",
          assessment: "Comprehensive Assessment",
          taskId: "232323",
          date: "December 22, 2022 10:30 AM",
          duration: "1 hour",
          status: "",
          button: "View Assessment",
        },
        {
            name: "Melanie Laurent",
            id: "324423",
            assessment: "Comprehensive Assessment",
            taskId: "232327",
            date: "December 22, 2022 10:30 AM",
            duration: "1 hour",
            status: "",
            button: "View Assessment",
          },
          {
            name: "Melanie Laurent",
            id: "32442",
            assessment: "Comprehensive Assessment",
            taskId: "23232212",
            date: "December 22, 2022 10:30 AM",
            duration: "1 hour",
            status: "",
            button: "View Assessment",
          },

    
   
  ];